module.exports = __webpack_public_path__ + "media/images/arrows/bullet-blue-e32f16e0ba599950229fe1f135eb2ad9.svg";